<app-abstract-action-confirmation-dialog
  (acceptEvent)="onAcceptClickedHandler()"
  (closeEvent)="onCloseClickedHandler()"
  (declineEvent)="onDeclineClickedHandler()"
  [acceptLabel]="data.acceptLabel"
  [cdkFocusInitialOnCancelButtonFlag]="data.cdkFocusInitialOnCancelButtonFlag"
  [declineLabel]="data.declineLabel"
  [formGroup]="formGroup"
  [formInvalidFlag]="formGroup.invalid"
  [messageLine1]="data.messageLine1"
  [messageLine2]="data.messageLine2"
  [note]="data.note"
  [subMessageLine1]="data.subMessageLine1"
  [subMessageLine2]="data.subMessageLine2"
>
  <div popup-form>
    <form [formGroup]="formGroup" class="mt-44">
      <app-combo
        [comboFormControl]="formGroup.controls.selectedValue"
        [keySelected]="formGroup.controls.selectedValue?.value?.key"
        [matLabel]="'Tarif client'"
        [options]="data.options"
        class="fxf-auto-fill-r"
      ></app-combo>
    </form>
  </div>
</app-abstract-action-confirmation-dialog>
